import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {HttpClientModule} from '@angular/common/http';
import {AuthModule} from './authentication/auth/auth.module';
import {environment} from '../environments/environment';

// mqtt settings
// export function factoryGetConfig(): Promise<TransportConfig> {
//   return new Promise((resolve) => resolve(environment.mqtt));
// }

@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
      BrowserModule,
      IonicModule.forRoot(),
      HttpClientModule,
      AuthModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      DragDropModule,
      // CoreModule.forRoot({
      //   apiRoot: environment.apiRoot,
      //   server: environment.server,
      //   logRoot: environment.logRoot,
      //   appOrigin: 'client',
      //   getTransportConfig: factoryGetConfig,
      //   calendar: environment.calendar
      // }),
    ],
    providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}],
    bootstrap: [AppComponent]
})
export class AppModule {}
